import React from 'react'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import { ErrorText } from './Common'
import { Link } from 'react-router-dom'

// Hide the browsers default checkbox
const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`

// Create a custom checkbox
const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #f3f3f3;

${''/* Create the checkmark indicator (hidden when not checked) */}
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`

// The container for the checkbox
const Label = styled.label`
  display: block;
  cursor: pointer;
  position: relative;
  font-size: 1.250em;
  padding-left: 35px;
  font-family: 'BarlowSemiBold';
  width: ${props => props.width};

  ${''/* On mouseover add a background color */}
  &:hover ${Input} ~ ${Checkmark} {
    background-color: #ccc;
  }

  ${''/* When the checkbox is checked add a bgcolor */}
  ${Input}:checked ~ ${Checkmark} {
    background-color: ${props => props.theme.color.bgYellow};
  }

  ${''/* Show the checkmark when checked */}
  ${Input}:checked ~ ${Checkmark}:after {
    display: block;
  }

${''/* Style the checkmark */}
  ${Checkmark}:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  @media ${device.tablet} {
    font-size: 0.9375vw;
  }
 `

const CheckBox = ({
  input,
  label,
  required,
  type,
  labelLong,
  meta: { touched, error, warning },
  ...props
}) => {
  return (
    // <Label {...props}> {labelLong ? <a href={to} target='_blank' className='iubenda-nostyle no-brand' title='Privacy Policy'>{required ? `${label}*` : label}</a> : required ? `${label}*` : label}
    <Label {...props}>{labelLong || label}
      <Input type={type} {...input} />
      <Checkmark />
      {touched && (error && <ErrorText>{error}</ErrorText>)}
    </Label>
  )
}

export default CheckBox



// WEBPACK FOOTER //
// ./src/components/UI/Form/Checkbox.js